import { Component, OnInit } from '@angular/core';
import { APP_PATH } from '@app/app.constants';
import { StudentClass } from '@df/interfaces';
import { PeopleService } from '@app/core/services';
import { HandlerService } from '@app/_services/handler.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-start-page',
    templateUrl: './start-page.component.html',
    styleUrls: ['./start-page.component.scss']
})
export class StartPageComponent implements OnInit {
    classes: Array<StudentClass> = [];
    APP_PATH = APP_PATH;
    isClasses = false;

    constructor(private peopleService: PeopleService, private handlerService: HandlerService, private router: Router) {}

    ngOnInit() {}

    private getClasses(): void {
        this.peopleService.getCurrentUserClasses().subscribe(resp => {
            this.handlerService.checkErrors(resp);
            if (resp.data.length > 0) {
                this.classes = resp.data;
                this.isClasses = true;
            }
        });
    }

    checkClasses(): void {
        if (!this.classes.length) {
            this.getClasses();
            return;
        }
        this.isClasses = true;
    }

    selectClass(selectedClassId: number) {
        const url = `/results/awards/${selectedClassId}`;
        this.router.navigate([url]).then();
    }
}
